import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { rgba } from 'polished'
import { fontSizeResponsive } from '../../theme/mixins'

export const modalStyles = {
  overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0.5)` },
  content: {
    right: `unset`,
    bottom: `unset`,
    top: !isMobile ? `50%` : window.innerWidth < 360 ? '2%' : `10%`,
    left: !isMobile ? `50%` : `5%`,
    transform: !isMobile ? `translate(-50%, -50%)` : `translate(0%, 0%)`,
    padding: `0px`,
    // minWidth: !isMobile ? `400px` : 'unset',
    // maxHeight: '50%',
    zIndex: 5,
    height: isMobile ? 'unset' : 'unset',
    maxHeight: !window.innerWidth < 360 ? '90vh' : '96%',
    width: isMobile ? '90%' : '550px',
    border: '1px solid #212121',
  },
}

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #212121;
  width: 100%;
  height: 100%;
  padding: 5%;
  box-sizing: border-box;

  @media (max-width: 600px) {
    padding: 10% 5% 5% 5%;
  }

  &.alternative-container {
    background-color: white;
  }

  &.no-internet {
    position: fixed;
    z-index: 10;
    top: 7%;
    left: 2%;
    width: 96%;
    height: min-content;
    padding: 10px;
    border-radius: 4px;
    border: 2px solid #cc0000;
    background-color: rgba(255 255, 255, 0.6);
    backdrop-filter: blur(2px);

    @media (max-width: 600px) {
      top: 15%;
    }
  }
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : 'wrap')};
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
`

export const Text = styled.span`
  display: ${(props) => (props.display ? props.display : 'inline')};
  width: ${(props) => (props.width ? props.width : 'unset')};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Asap')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  font-size: ${(props) =>
    props.fontSize
      ? fontSizeResponsive(props.fontSize)
      : fontSizeResponsive(18)};
  font-stretch: ${(props) =>
    props.fontStretch ? props.fontStretch : 'normal'};
  color: ${(props) => (props.color ? props.color : '#ffffff')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
`

export const Image = styled.div`
  position: relative;
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : '100%')};
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '100%')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};

  background-image: ${(props) => (props.src ? `url(${props.src})` : 'unset')};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const CalendarTile = styled.div`
  position: relative;
  width: calc(25% - 6px);
  height: calc(550px / 5 + 7px);
  border-radius: 4px;
  background-color: white;
  box-sizing: border-box;
  padding: 10px;
  margin: 3px;
  display: ${(props) => (props.display ? props.display : 'flex')};
  flex-direction: ${(props) => (props.fDir ? props.fDir : 'column')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};

  &.active {
    background-color: #faad02;
  }

  @media (max-width: 600px) {
    width: 18.5vw;
    height: 18.5vw;
  }

  @media (max-width: 360px) {
    width: 18vw;
    height: 18vw;
  }
`

export const ActiveDayCompletedIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1eee81;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2.8px 2.4px rgba(0, 0, 0, 0.048),
    0 6.7px 5.9px rgba(0, 0, 0, 0.069), 0 12.5px 11px rgba(0, 0, 0, 0.085),
    0 22.3px 19.7px rgba(0, 0, 0, 0.101), 0 41.8px 36.8px rgba(0, 0, 0, 0.122),
    0 100px 88px rgba(0, 0, 0, 0.17);

  background-image: ${(props) => (props.src ? `url(${props.src})` : 'unset')};
  background-size: 45%;
  background-repeat: no-repeat;
  background-position: center;
`

export const Button = styled.button`
  width: ${(props) => (props.width ? props.width : '100%')};
  font-family: 'Asap';
  font-stretch: condensed;
  font-weight: bold;
  font-size: ${fontSizeResponsive(28)};
  text-transform: uppercase;
  padding: 10px 20px;
  box-sizing: border-box;
  background-image: linear-gradient(to right, #fe0d9f, #faad02 100%);
  color: white;
  border: none;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};

  @media (max-width: 600px) {
    font-size: ${fontSizeResponsive(22)};
  }

  &.minimal {
    color: #fe0da0;
    background-image: unset;
    background-color: transparent;
    font-weight: normal;
  }
`

// Redesign styles:

export const PlayerBox = styled.div`
  width: ${(props) => (props.isMobile ? '100%' : '50%')};
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? '0' : '3%')};

  @media screen and(max-width: 800px) and (orientation: landscape) {
    margin-top: 0;
  }

  /* player video styles */
  .player {
    width: 100% !important;
    height: ${(props) =>
      props.isMobile ? ' 40% !important' : 'auto !important'};
    max-height: ${(props) => (props.isMobile ? '40%' : 'unset')};
  }
`

export const PlayerControlsBox = styled.div`
  width: ${(props) =>
    props.isFullscreen && !props.isMobile
      ? '43vw'
      : props.isFullscreen && props.isMobile
      ? '95vw'
      : '85%'};
  margin-top: ${(props) => (props.isFullscreen ? 'unset' : '3%')};
  padding: ${(props) => (props.isFullscreen ? '1%' : '2%')};
  box-sizing: border-box;
  opacity: ${(props) => (props.isFullscreen ? '1' : '0.77')};
  border-radius: 30px;
  background-image: linear-gradient(to right, #728ffb, #e896b1 98%);

  position: ${(props) =>
    props.isFullscreen || props.isMobile ? 'absolute' : 'relative'};
  top: ${(props) =>
    props.isFullscreen && !props.isMobile
      ? '85%'
      : props.isFullscreen && props.isMobile
      ? '70%'
      : 'unset'};
  left: ${(props) =>
    props.isFullscreen && !props.isMobile
      ? '28.5vw'
      : props.isFullscreen && props.isMobile
      ? '2.5vw'
      : '7.5%'};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  transition: all 1.3s cubic-bezier(0.215, 0.61, 0.355, 1);

  opacity: ${(props) =>
    props.shouldHideControls && (props.isFullscreen || props.isHorizontalMobile)
      ? '0'
      : '1'};

  &.is-safari {
    padding-top: 6%;
    margin-top: 5%;
  }

  bottom: ${(props) => (props.isFullscreen ? 'unset' : '25%')};

  @media only screen and (max-device-width: 1000px) and (orientation: landscape) {
    margin-top: ${(props) =>
      props.isFullscreen && props.isMobile ? '3%' : '-15%'};
    bottom: 1%;
  }
`

export const ControlsButtonWrapper = styled.div`
  display: flex;
  width: 33%;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;

  &.mobile-full-width {
    width: 100%;
  }
`

export const PlayerRow = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};

  &.is-safari {
    padding: 5% 0 0 0;
  }
`

export const PlayerProgressbar = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: 5px;
  background-color: #342152;
  border-radius: 4px;

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: ${(props) => (props.value ? `${props.value}%` : 0)};
    height: 100%;
    background-color: #a1ff68;
  }
`

export const ControlButton = styled.button`
  background-color: transparent;
  border: none;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};

  &.inactive {
    opacity: 0.4;
    filter: blur(1px) grayscale(0.5);
    cursor: not-allowed;
  }
`

export const playerInlineStyles = {
  width: '100%',
  height: 'auto',
}
